import React from 'react';

import {
  maskName,
  useTranslation,
  exchangeAmountByRate,
  parseNumberByPrecision,
  userInfoStore,
} from '@pascal/pascal-core';

const WinnerContentItem = ({ data }) => {
  const t = useTranslation();
  const { userId, currencySymbolOrCode } = userInfoStore;

  return data.map((item, index) => {
    const exchange = exchangeAmountByRate(item);

    return (
      <div className='c-m-winner-content-row' key={index}>
        <span className='c-m-winner-amount'>{`${parseNumberByPrecision(
          exchange.winAmount,
          1
        )} ${currencySymbolOrCode}`}</span>
        <span className='c-m-winner-id'>
          {item.playerId
            ? +userId === item.userId
              ? t('ME')
              : `ID ${maskName(item.playerId)}`
            : t('ME')}
        </span>
      </div>
    );
  });
};

export default WinnerContentItem;
